import { IStockMoveError } from "@app/interface/movement";

export class StockMoveError implements IStockMoveError {
  code: string;
  internCode: number;
  hasError: boolean;
  message: string;
  stack: string;
  status: string;
  statusText: string;
  type: string;
  url: string;

  constructor (error: any) {
    this.hasError = true;
    this.code = error?.code || error?.status?.toString() || error?.error?.code || null;
    this.message = error?.message || error?.statusText || 'Unknown error';
    this.stack = error?.stack || null;
    this.status = error?.status?.toString();
    this.statusText = error?.statusText || '';
    this.type = error?.type || error?.name || 'error';
    this.url = error?.url || error?.urlWithParams || '';
    this.internCode = error?.error?.error ?? 500;
  }
}